export default __webpack_public_path__ + "static/media/replace_image.d985835e.svg";